import React, { useEffect, useState } from 'react';
import { Button, Center, Modal, Text } from '@mantine/core';
import classes from '../beginners/Beginner.module.css'; // Adjust the path as necessary
import { useDisclosure } from '@mantine/hooks';
import LevelRow from './levelRow/levelRow';
import useGetAdvanced from './useGetAdvanced';

function BonusPage() {

    // State for steps and global currency selection
    const {
        AdvanceQuery: { data: allData, loading: allIsLoading },
    } = useGetAdvanced()

    const [opened, { open, close }] = useDisclosure(false);

    const [steps, setSteps] = useState([
        {
            id: 1,
            name: "Level 1",
            typeOfMonth: [],
            fields: [
                { label: "Monthly Income (Minimum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                { label: "Monthly Income (Maximum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                { label: "Live Days (optional)", value: "", currency: "Days", fixed: true, placeholder: "Enter Value" },
                { label: "Live Hours (optional)", value: "", currency: "Hours", fixed: true, placeholder: "Enter Value" },
                { label: "Bonus Managers (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
                { label: "Bonus Agents (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
                { label: "Bonus Creators (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
            ],
        },
    ]);

    console.log({ steps });

    useEffect(() => {
        if (allData && allData.length > 0) {
            const newSteps = allData?.map((data, index) => ({
                id: data.id,
                typeOfMonth: data.bonus_type_of_months,
                name: data.name || `Level ${steps.length + 1}`,
                fields: [
                    { label: "Monthly Income (Minimum)", value: data.minimum_monthly_income, currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                    { label: "Monthly Income (Maximum)", value: data.maximum_monthly_income, currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                    { label: "Live Days (optional)", value: data.live_days, currency: "Days", fixed: true, placeholder: "Enter Value" },
                    { label: "Live Hours (optional)", value: data.live_hours, currency: "Hours", fixed: true, placeholder: "Enter Value" },
                    { label: "Bonus Managers (optional)", value: data.bonus_manager, currency: "Diamonds", placeholder: "Enter %" },
                    { label: "Bonus Agents (optional)", value: data.bonus_agent, currency: "Diamonds", placeholder: "Enter %" },
                    { label: "Bonus Creators (optional)", value: data.bonus_creator, currency: "Diamonds", placeholder: "Enter %" },
                ],
            }));

            setSteps(newSteps);
        }
    }, [allData]); // Runs when `data` updates

    // Add a new step
    const addStep = () => {
        console.log({ steps });
        setSteps([
            ...steps,
            {
                id: steps.length + 1,
                name: `Level ${steps.length + 1}`,
                typeOfMonth: [],
                fields: [
                    { label: "Monthly Income (Minimum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                    { label: "Monthly Income (Maximum)", value: "", currency: "Diamonds", fixed: true, placeholder: "Enter Value" },
                    { label: "Live Days (optional)", value: "", currency: "Days", fixed: true, placeholder: "Enter Value" },
                    { label: "Live Hours (optional)", value: "", currency: "Hours", fixed: true, placeholder: "Enter Value" },
                    { label: "Bonus Managers (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
                    { label: "Bonus Agents (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },
                    { label: "Bonus Creators (optional)", value: "", currency: "Diamonds", placeholder: "Enter %" },

                ],
            },
        ]);

    };

    const removeUnusedSteps = (index) => {
        setSteps((prevSteps) => {
            const updatedSteps = [...prevSteps]; // Create a copy
            updatedSteps.splice(index, 1); // Remove the step at the given index
            return updatedSteps; // Update state
        });
    }




    return (
        <div>
            <div className={classes.wrapper}>

                <h1>Advanced Bonus</h1>


            </div>

            <Button variant="outline" onClick={addStep} style={{ marginBottom: "20px" }}>
                + Add Step
            </Button>
            &nbsp;
            <Button variant="outline" color="red" onClick={open} style={{ marginBottom: "20px" }} >
                Return
            </Button>

            {steps.map((step, index) => (


                <LevelRow index={index} key={step?.id + ''} stepData={step} removeUnusedSteps={removeUnusedSteps} />



            ))
            }
            <Modal opened={opened} onClose={close}
                centered
                title="Confirm">

                <Text>Are you sure you want to leave this page?</Text>


                <Center mt={"md"}>
                    <Button onClick={() => window.history.back()}
                    >Confirm</Button>
                </Center>

            </Modal >
        </div >
    );
}

export default BonusPage;
